import { Card } from 'react-bootstrap'
import { useCuit } from './Hooks'

function Error() {
  const cuit = useCuit()

  return (
    <>
      <Card className="text-center p-5" bg="danger" text="white">
	<Card.Title>Error!</Card.Title>
	<Card.Text>
	  La CUIT {cuit} ya se encuentra registrada, no es posible registrarse nuevamente.
	</Card.Text>
      </Card>
    </>
  )
}

export default Error
